import { Button, UIText2 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ETestIds } from '../../constants';
import { NBSP } from 'shared/common/constants';

interface IFillApplicationStickyButtonProps {
  onClick: () => void;
  loading?: boolean;
}

export const FillApplicationStickyButton = ({ onClick, loading = false }: IFillApplicationStickyButtonProps) => {
  return (
    <div className={styles['mobile-btn']} data-testid={ETestIds.MobileCtaButton}>
      <div className={styles['mobile-wrapper']}>
        <Button
          fullWidth
          size="M"
          onClick={onClick}
          loading={loading}
          disabled={loading}
          data-testid={ETestIds.MainButton}
        >
          Заполнить заявку на Циане
        </Button>
        <div>
          <UIText2 textAlign={'center'} color={'text-secondary-default'}>
            {`Заявка${NBSP}— единая для всех банков.`}
          </UIText2>
          <UIText2 textAlign={'center'} color={'text-secondary-default'}>
            {`Перед${NBSP}заполнением попросим авторизоваться.`}
          </UIText2>
        </div>
      </div>
    </div>
  );
};
